<form class="event-form" [formGroup]="eventForm()">
  <ng-container formArrayName="products">
    @for (product of products.controls; track product; let i = $index) {
      <ng-container [formGroupName]="i">
        <div class="event-form__product">
          <mat-form-field class="event-form__input" appearance="fill">
            <mat-label for="name">Product Name</mat-label>
            <input matInput formControlName="name" placeholder="Shoutout" />
            @if (
              product.get("name")?.hasError("required") &&
              (product.get("name")?.dirty || product.get("name")?.touched)
            ) {
              <mat-error>Name is required.</mat-error>
            }
            @if (
              product.get("name")?.hasError("minlength") &&
              (product.get("name")?.dirty || product.get("name")?.touched)
            ) {
              <mat-error>Minimum 2 characters required.</mat-error>
            }
            @if (
              product.get("name")?.hasError("maxlength") &&
              (product.get("name")?.dirty || product.get("name")?.touched)
            ) {
              <mat-error>Maximum 50 characters allowed.</mat-error>
            }
          </mat-form-field>
          <mat-form-field
            class="event-form__input event-form__input--price"
            appearance="fill"
          >
            <mat-label for="amount">Price</mat-label>
            <span matTextPrefix>$</span>
            <input matInput formControlName="amount" type="number" />
            @if (
              product.get("amount")?.hasError("required") &&
              (product.get("amount")?.dirty || product.get("amount")?.touched)
            ) {
              <mat-error>Price is required.</mat-error>
            }
            @if (
              product.get("amount")?.hasError("min") &&
              (product.get("amount")?.dirty || product.get("amount")?.touched)
            ) {
              <mat-error>Minimum price is $2.</mat-error>
            }
            @if (
              product.get("amount")?.hasError("max") &&
              (product.get("amount")?.dirty || product.get("amount")?.touched)
            ) {
              <mat-error>Maximum price is $100.</mat-error>
            }
          </mat-form-field>
          <div class="event-form__product-actions">
            @if (!product.get("isDefault")?.value) {
              <button
                mat-fab
                color="warn"
                (click)="removeProduct(i)"
                type="button"
              >
                <mat-icon>delete</mat-icon>
              </button>
            } @else {
              <mat-icon
                class="event-form__default-icon"
                matTooltip="Default product (cannot be deleted)"
                >star</mat-icon
              >
            }
          </div>
        </div>
      </ng-container>
    }
  </ng-container>
  <button
    class="event-form__submit"
    mat-raised-button
    color="secondary"
    (click)="addProduct()"
    type="button"
  >
    <mat-icon>add</mat-icon>
    Add Product
  </button>
</form>
